import { maxLength, minLength, numeric } from '@reliance/forms-js/lib/validation';
import { Facility } from '@reliance/types/models/Facility';
import { FORM_ERROR } from 'final-form';
import React from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { Form } from 'react-final-form';
import { alertStore } from '../alert/alertStore';
import api from '../common/api';
import { States } from '../form/States';
import { TextInput } from '../form/TextInput';

type EditBillingProps = {
  facility: Facility;
  onSave(): any;
};

const EditBilling: React.FC<EditBillingProps> = (props) => {
  const initialValues = {
    billingName: props.facility.billingName,
    billingAddress1: props.facility.billingAddress1,
    billingAddress2: props.facility.billingAddress2,
    billingCity: props.facility.billingCity,
    billingState: props.facility.billingState,
    billingZip: props.facility.billingZip,
  };

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(formData) =>
        api.put(`/facility/${props.facility.id}`, formData)
          .then(() => alertStore.success('Facility was successfully saved'))
          .then(() => localStorage.removeItem('cachedFacilities'))
          .then(props.onSave)
          .catch((err) => ({ [FORM_ERROR]: err }))
      }
      render={(form) =>
        <form onSubmit={form.handleSubmit}>
          <Card>
            <Card.Body>
              <TextInput
                label="Name"
                validationRules={[minLength(1), maxLength(50)]}
                name="billingName" />

              <TextInput
                label="Address"
                validationRules={[minLength(1), maxLength(50)]}
                name="billingAddress1" />
              <TextInput
                validationRules={[maxLength(50)]}
                name="billingAddress2" />

              <TextInput
                label="City"
                validationRules={[minLength(1), maxLength(50)]}
                name="billingCity" />

              <States
                includeEmpty={true}
                abbreviations={true}
                name="billingState"
                label="State" />

              <TextInput
                label="Zip"
                validationRules={[numeric, minLength(5), maxLength(5)]}
                name="billingZip" />
            </Card.Body>
            <Card.Footer>
              <Button
                variant="primary"
                disabled={form.submitting || form.hasValidationErrors}
                type="submit">
                Save
              </Button>
            </Card.Footer>
          </Card>
        </form>
      } />
  );
};

export default EditBilling;
